import { bootstrapAnimations } from './bootstrap.mjs';

if (typeof document !== 'undefined') {
    const config =
        typeof window !== 'undefined' && window.__SPEEDER_ANIMATIONS_CONFIG__
            ? window.__SPEEDER_ANIMATIONS_CONFIG__
            : null;
    const autoOptions = {
        ...(config || {}),
    };

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            () => {
                bootstrapAnimations(document, autoOptions);
            },
            { once: true }
        );
    } else {
        bootstrapAnimations(document, autoOptions);
    }
}
